<script lang="ts">
export interface ComboboxVirtualizerProps<TOption, TValue> extends VirtualizerProps {
	options: ListOption<TOption, TValue>[];
}
</script>

<script setup lang="ts" generic="TOption, TValue">
import { injectComboboxRootContext, ListboxVirtualizer } from "reka-ui";
import type { ListOption } from "../listbox/listbox";
import type { VirtualizerProps } from "../virtualizer/virtualizer";

const props = defineProps<ComboboxVirtualizerProps<TOption, TValue>>();

defineSlots<{
	default(slotProps: { option: ListOption<TOption, TValue> }): any;
}>();

const comboboxContext = injectComboboxRootContext();
comboboxContext.isVirtual.value = true;
</script>

<template>
	<ListboxVirtualizer
		v-if="props.virtual"
		v-slot="{ option }"
		:options="options"
		:estimateSize="props.estimateHeight"
		:overscan="props.overscan"
	>
		<slot :option="option" />
	</ListboxVirtualizer>

	<template v-else v-for="option of options" :key="option.value">
		<slot :option="option" />
	</template>
</template>
